module.exports = __webpack_public_path__ + "img/a14.2dfae69b.png";